module.exports = __webpack_public_path__ + "img/tyre.503a4348.png";